import EntityAssociations from "../../../../../entityAssociations";

export default function EntityEntities() {
  return (
    <div
      className="flex h-full w-full flex-col gap-3 overflow-y-auto rounded-[14px] bg-white p-6"
    >
      <EntityAssociations />
    </div>
  );
}
